module.exports = __webpack_public_path__ + "img/shot_tx19112801.1b17dedb.jpg";